/* eslint-disable no-debugger */
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';

import useNTAttachmentData from '../../../state/nationalTeamAttachment/UseNTAttachmentData';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import useBasePersonData from '@usas/ui-web/state/personBase/UseBasePersonData';

import { openFileInNewTab } from '@usas/ui-web/utils/FileUtils';

const INITIAL_STATE = {
  attachmentObj: undefined
};

const useProfilePublicAttachmentDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { navRoutes } = useNavRoutes();
  const { basePersonState } = useBasePersonData();
  const { nationalTeamAttachmentUploadState, nationalTeamAttachmentUpdateState, nationalTeamAttachmentDownloadState,
    nationalTeamAttachmentState, postNTAttachment, putNTAttachment, getNTAttachment, getNTAttachmentsByPersonId
  } = useNTAttachmentData();
  const [state, setState] = useState(INITIAL_STATE);

  const onCancelClicked = (event) => {
    event?.preventDefault();

    navigate(navRoutes.MEMBER_PROFILE_PUBLIC_ATTACHMENTS?.route);
  };

  const onDownloadFileClicked = async (event, attachmentUrl, isPublic) => {
    event?.preventDefault();

    const getNTAttachmentResult = await getNTAttachment(attachmentUrl, isPublic);

    openFileInNewTab(getNTAttachmentResult.objData?.downloadUrl);
  };

  const onSubmitAttachmentForm = async (formState) => {
    if (state.attachmentObj) {
      const newAttachmentObj = {
        ...state.attachmentObj,
        personId: basePersonState.objData.personId,
        attachmentDescription: formState.attachmentDescription,
        attachmentName: formState.attachmentName
      };

      const putNTAttachmentResult = await putNTAttachment(newAttachmentObj.personNationalAttachmentId, newAttachmentObj, formState.attachmentFile?.size > 0 ? formState.attachmentFile : undefined, formState.isPublic);

      if (putNTAttachmentResult) {
        await getNTAttachmentsByPersonId(basePersonState.objData.personId, true);

        navigate(navRoutes.MEMBER_PROFILE_PUBLIC_ATTACHMENTS?.route);
      }
    } else {
      const newAttachmentObj = {
        personId: basePersonState.objData.personId,
        personNationalAttachmentFileTypeId: formState.fileTypeId,
        attachmentDescription: formState.attachmentDescription,
        attachmentName: formState.attachmentName
        // attachmentName: 'BioHeadshot_' + formState.attachmentName
      };

      let attachmentFileObj = formState.attachmentFile;

      const postNTAttachmentResult = await postNTAttachment(attachmentFileObj, newAttachmentObj, formState.isPublic);
      // const postNTAttachmentResult = await postNTAttachment(newAttachmentObj.attachmentName, newAttachmentObj, formState.isPublic);

      if (postNTAttachmentResult) {
        await getNTAttachmentsByPersonId(basePersonState.objData.personId, true);

        navigate(navRoutes.MEMBER_PROFILE_PUBLIC_ATTACHMENTS?.route);
      }
    }
  }

  useEffect(() => {
    if (location?.state?.attachmentObj) {
      setState({
        ...state,
        attachmentObj: location.state.attachmentObj
      });
    } else {
      setState({
        ...state,
        attachmentObj: null
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    basePersonState,
    isSaving: nationalTeamAttachmentUploadState.isObjLoading || nationalTeamAttachmentUpdateState.isObjLoading,
    isLoading: nationalTeamAttachmentDownloadState.isObjLoading || nationalTeamAttachmentState.isArrayLoading,
    attachmentObj: state.attachmentObj,
    nationalTeamAttachmentState,
    onCancelClicked,
    onDownloadFileClicked,
    onSubmitAttachmentForm
  };
};

export default useProfilePublicAttachmentDetail;
